import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* startPublishingSaga() {
  if (RTCClient.publishingFeed.broadcastIntended) {
    yield call(RTCClient.publishingFeed.attachPlugin);
  }
}
